import { analog_bjt } from './analog_bjt';

export class nsvbcp5316mtwg extends analog_bjt {}
